import { Head } from '@inertiajs/react'
import DashboardLayout from '@/frontend/layouts/DashboardLayout'
import FdeShell from '@/frontend/features/Fde/FdeShell'
import ProjectTeamAccess from '@/frontend/features/Fde/ProjectTeamAccess'
import ProjectTeamAgents from '@/frontend/features/Fde/ProjectTeamAgents'
import type { ManagementProps } from '@/frontend/features/Fde/types'
import type { ProjectTeamPerson } from '@/frontend/features/Fde/projectTeamTypes'

function ProjectTeam(props: ManagementProps & { team_view: 'agents' | 'access'; team_people: ProjectTeamPerson[] }) {
  return <><Head title={props.page_title} /><FdeShell copy={props.copy} eyebrow="" title={props.project?.name || props.organization.name} description="" projectId={props.project?.id}>
    {props.team_view === 'agents' ? <ProjectTeamAgents key={props.project?.id} props={props} /> : <ProjectTeamAccess key={props.project?.id} props={props} />}
  </FdeShell></>
}
ProjectTeam.layout = (page: React.ReactElement) => <DashboardLayout variant="fullscreen">{page}</DashboardLayout>
export default ProjectTeam
